import { createUsergroupActions } from '../../constants';

export const createUserGroup = () => ({
  type: createUsergroupActions.CREATE_USERGROUP,
});

export const createUserGroupSuccess = (category, code, userGroupSourceCode, result) => ({
  type: createUsergroupActions.CREATE_USERGROUP_SUCCESS, category, code, userGroupSourceCode, result,
});

export const createUserGroupError = (error) => ({
  type: createUsergroupActions.CREATE_USERGROUP_ERROR,
  error,
});

export const showSaveUserGroupDialog = (category, code) => ({
  type: createUsergroupActions.SHOW_SAVE_USERGROUP_DIALOG,
  category,
  code,
});

export const hideSaveUserGroupDialog = () => ({
  type: createUsergroupActions.HIDE_SAVE_USERGROUP_DIALOG,
});

export const newUserGroupFromSource = (category, code, userGroupSourceCode) => ({
  type: createUsergroupActions.NEW_USERGROUP_FROM_SOURCE,
  category,
  code,
  userGroupSourceCode,
});
